<script>
import { eventBus } from '../../../../../../../../Pages/assets/eventBus.js'
export default {
    methods: {
        viewAll() {
            eventBus.viewAllFoldersFiles('Folders');
        }
    }
};
</script>

<template>
    <div class="ms-auto m-2">
        <a href="javascript: void(0);" @click="viewAll">View All</a>
    </div>
</template>
